export default "Aides Collectivités — CEE, Fonds Vert, DETR/DSIL, Fonds Chaleur | Solution Éco France";
